import { collectSearchKeys } from './collectSearchKeys.js'
import { matchesMentionQuery } from './matchesMentionQuery.js'
import { filterAndCap } from './filterAndCap.js'
import { MAX_PER_SECTION } from './mentionConstants.js'

/**
 * @typedef {{
 *   id: string,
 *   kind: 'user' | 'agent',
 *   label: string,
 *   subtitle: string,
 *   name: string,
 *   email?: string,
 *   role?: string,
 *   avatarSrc?: string | null,
 *   avatarAlt?: string,
 * }} MentionSuggestion
 */

/**
 * @param {string} name
 * @param {string} [email]
 * @param {string} [role]
 */

/**
 * @param {string} query
 * @param {Set<string>} keys
 */

/**
 * @param {Array<{ email: string, name: string }>} members
 * @returns {MentionSuggestion[]}
 */

export function buildUserMentionSuggestions(members) {
  return (members ?? []).map((m) => ({
    id: `user:${m.email}`,
    kind: 'user',
    label: m.name,
    subtitle: m.email,
    name: m.name,
    email: m.email,
    _keys: collectSearchKeys(m.name, m.email),
  }))
}

/**
 * @param {Array<{ id: string, name: string, role?: string, avatarSrc?: string | null, avatarAlt?: string }>} agents
 * @returns {MentionSuggestion[]}
 */
